<template>
  <div class="loader mt-220" v-if="loading">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div class="mt-80 w-100 pb-4" v-else>
    <form @submit.prevent="UpdateStory" class="article">
      <div class="article-width">
        <b-row class="article-img">
          <b-col cols="12">
            <div class="img-wrapper">
              <div class="img-holder image-block">
                <img :src="story.picture" class="img-fluid img-responsive contain image-content" alt="">
              </div>
            </div>
          </b-col>
        </b-row>
        <div @click="edit = !edit">
          <span v-if="edit">Читать</span>
          <span v-else>редактировать</span>
        </div>
        <h1 v-if="!edit" class="article-title">{{story.title}}</h1>
        <b-form-input v-else type="text" class="title-input w-100 edit-title-input" placeholder="Заголовок" v-model="story.title"/>
        <pre v-if="!edit"  class="article-text"><p class="textWrap">{{story.text}}</p></pre>
        <textarea v-else type="text" class="text-input edit-text-input" placeholder="Текст" v-model="story.text"></textarea>
        <button v-if="edit" type="submit" class="type-submit">Обновить историю</button>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    metaInfo: {
      title: `Истории`,
    },
    name: "Story",
    data() {
      return {
        story: null,
        loading: true,
        edit: false,
      }
    },
    async mounted() {
      this.loading = true
      const id = this.$route.params.id
      this.story = await this.fetchStoryById(id)
      this.loading = false
    },
    computed: {
      ...mapGetters('stories', ['getStories'])
    },
    methods: {
      ...mapActions('stories', ['fetchStoryById', 'updateStory']),
      async UpdateStory() {
        await this.updateStory(this.story)
        this.edit = false
      }
    }
  }
</script>

<style lang="scss">
  input.title-input.edit-title-input {
    width: 100% !important;
  }
  textarea.text-input.edit-text-input {
    height: 700px !important;
  }
</style>